export default __webpack_public_path__ + "static/media/agent2.e662c5d0.png";